import { Stack, styled } from "@mui/material";

export const ButtonIconCircle = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  background: theme.palette.dsSurface.v200,
  padding: theme.spacing(1.5),
  borderRadius: "50%",
  height: theme.spacing(5),
  width: theme.spacing(5),
  boxSizing: "border-box",
}));
